import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BlobWrapper = styled.div.withConfig({
  displayName: "Blob__BlobWrapper",
  componentId: "sc-17a25wl-0"
})(["position:relative;opacity:1;width:350px;height:370px;display:flex;align-items:center;justify-content:center;"]);
const BackgroundBlob = styled.div.withConfig({
  displayName: "Blob__BackgroundBlob",
  componentId: "sc-17a25wl-1"
})(["position:absolute;opacity:1;width:350px;height:370px;display:flex;align-items:center;justify-content:center;background:#fef8f0;border-radius:41% 59% 56% 44% / 33% 39% 61% 67%;z-index:", ";pointer-events:none;will-change:transform,border-radius;"], props => props.zIndex ? props.zIndex + 1 : -2);
const BackgroundBlobBright = styled.div.withConfig({
  displayName: "Blob__BackgroundBlobBright",
  componentId: "sc-17a25wl-2"
})(["position:absolute;opacity:1;width:320px;height:320px;display:flex;align-items:center;justify-content:center;background:#fae0b5;border-radius:28% 72% 40% 60% / 29% 71% 29% 71%;z-index:", ";pointer-events:none;will-change:transform,border-radius;"], props => props.zIndex ? props.zIndex + 1 : -1);
const ChildComponentWrapper = styled.div.withConfig({
  displayName: "Blob__ChildComponentWrapper",
  componentId: "sc-17a25wl-3"
})(["z-index:", ";"], props => props.zIndex ? props.zIndex + 3 : 0);
const Blob = ({
  renderComponent,
  zIndex
}) => {
  return /*#__PURE__*/_jsxs(BlobWrapper, {
    children: [/*#__PURE__*/_jsx(BackgroundBlob, {
      zIndex: zIndex
    }), /*#__PURE__*/_jsx(BackgroundBlobBright, {
      zIndex: zIndex
    }), /*#__PURE__*/_jsx(ChildComponentWrapper, {
      zIndex: zIndex,
      children: renderComponent()
    })]
  });
};
export default Blob;